export default function callTrkSwap() {
    if (window.CallTrk?.swap) {
        window.CallTrk.swap();
    }
}
